import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import NewSkillBox from './NewSkillBox';

gsap.registerPlugin(ScrollTrigger);

const Skills = () => {
  const skillRef = useRef(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      let skillRefEl = skillRef.current;

      let tl = gsap.timeline();
      tl.set('#skills', {
        xPercent: 800,
        opacity: 0,
      });
      tl.set('#hero-whole', {
        opacity: 1,
      });
      tl.to(skillRefEl, {
        xPercent: 0,
        opacity: 1,
      });
      tl.to('#hero-whole', {
        opacity: 0,
      });

      ScrollTrigger.create({
        trigger: '#skills-content',
        start: 'top 100%',

        end: 'top top',
        pin: '#hero-whole',
        pinSpacing: false,
        scrub: true,
        animation: tl,
      });
    }
  }, []);

  return (
    <div id="skills-relative">
      <div id="text-container">
        <div ref={skillRef} id="skills">
          Skills
        </div>
        <div id="complete">
          <NewSkillBox />
        </div>
      </div>
    </div>
  );
};

export default Skills;
